import { SxProps } from '@mui/material';
import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { PInputState } from '@/components/atoms/inputState';
import { PRadioButton } from '@/components/molecules/RadioButton/PRadioButton';

type Props = {
  name: string;
  icon?: string;
  title: string;
  titleTooltip?: ReactNode;
  subtitle?: string;
  onChange?: (value: boolean) => void;
  state?: PInputState;
  sx?: SxProps;
};

export default function RHFRadioButton({ name, icon, title, titleTooltip, subtitle, onChange, state, sx }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <PRadioButton
          checked={Boolean(field.value)}
          onClick={() => {
            field.onChange(!field.value);
            onChange?.(!field.value);
          }}
          icon={icon}
          title={title}
          titleTooltip={titleTooltip}
          subtitle={subtitle}
          state={state}
          sx={sx}
        />
      )}
    />
  );
}
